import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import MemberBusinesses from './Businesses'
import MemberFavorites from './Favorites'
import MemberSchedules from './Schedules'
import MemberUserData from './UserData'
import { Container, TabRow, TabButton, Title } from './styles'

export default function MemeberArea (props) {
  const location = useLocation ()
  const configOption = location.state?.configOption ?? null
  
  const TAB_LIST = [
    {label: 'Salões', value: 'member-businesses', component: <MemberBusinesses {...props}/>},
    {label: 'Favoritos', value: 'member-favorites', component: <MemberFavorites {...props}/>},
    {label: 'Agendamentos', value: 'member-schedules', component: <MemberSchedules {...props}/>},
    {label: 'Meus dados', value: 'member-userdata', component: <MemberUserData/>},
  ]

  const [selectedTab, setSelectedTab] = useState (
    configOption ?? localStorage.getItem ('config_tab') ?? TAB_LIST[0].value
  )
  
  return (
    <Container style={{paddingLeft: 50}}>
      <Title>Area do membro</Title>
      <TabRow>
        {TAB_LIST.map ((tab, index) => (
          <TabButton
            key={index}
            selected={selectedTab === tab.value}
            color={selectedTab === tab.value ? '#FFC100' : '#FFFFFF'}
            onClick={() => {
              setSelectedTab (tab.value)
              localStorage.setItem ('config_tab', tab.value)
            }}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabRow>
      {TAB_LIST.find (tab => tab.value === selectedTab)?.component}
    </Container>
  )
}
